import React from "react";
import { ManageAIPromptsContent } from "../components/AIMaster/ManageAIPromptsContent";
import { ToastContainer } from "react-toastify";

export const AIPromptMasters = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAIPromptsContent />
        </div>
      </div>
    </div>
  );
};
